<template>
  <div>
    <div class="row">
      <div v-for="(card,index) in cards" :key="card.title">
        <div :class="{lightgrey: index % 2 === 0}" class="col s12">
          <div class="col s12 m10 l8 offset-m1 offset-l2">
            <h2 class="header">{{$t(card.title)}}</h2>
            <div class="card horizontal">
              <div class="card-image">
                <img :src="card.img.link" :alt="$t(card.img.alt)"/>
              </div>
              <div class="card-stacked">
                <div class="card-content">
                  <p v-html="$t(card.desc)"></p>
                </div>
                <div class="card-action"><p v-html="$t(card.action)"></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Android',
  data () {
    return {
      cards: [{
        title: 'android.cmts.title',
        img: {link: 'static/img/cmts.png', alt: 'android.cmts.alt.pict'},
        desc: 'android.cmts.desc',
        action: 'android.cmts.action'
      }, {
        title: 'android.accounts.title',
        img: {link: 'static/img/gestionnaireAndroid.png', alt: 'android.accounts.alt.pict'},
        desc: 'android.accounts.desc',
        action: 'android.accounts.action'
      }, {
        title: 'android.zenith.title',
        img: {link: 'static/img/application_zenith_limoges.png', alt: 'android.zenith.alt.pict'},
        desc: 'android.zenith.desc',
        action: 'android.zenith.action'
      }, {
        title: 'android.muscu.title',
        img: {link: 'static/img/android_chrono.png', alt: 'android.muscu.alt.pict'},
        desc: 'android.muscu.desc',
        action: 'android.muscu.action'
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Android.vue